import { render } from "./SpecsCard.vue?vue&type=template&id=396975da"
import script from "./SpecsCard.vue?vue&type=script&lang=js"
export * from "./SpecsCard.vue?vue&type=script&lang=js"

import "./SpecsCard.vue?vue&type=style&index=0&id=396975da&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tests/SpecsCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "396975da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('396975da', __exports__)) {
    api.reload('396975da', __exports__)
  }
  
  module.hot.accept("./SpecsCard.vue?vue&type=template&id=396975da", () => {
    api.rerender('396975da', render)
  })

}


export default __exports__